import { getDefaultRouteForLevel, isRouteAllowedForLevel } from '@/utils/accessControl';

export const PUBLIC_ROUTES = ['/', '/login', '/signup', '/reset-password', '/email-confirmed'];

export const resolveAuthGuardDecision = ({
  user,
  loading,
  accessLevel,
  accessLoading,
  path,
  asPath,
  redirectToQuery,
}) => {
  if (loading || accessLoading) {
    return { authorized: false, redirect: null };
  }

  const isPublic = PUBLIC_ROUTES.includes(path);

  if (!user && !isPublic) {
    const query = asPath && asPath !== '/login' && asPath !== '/signup'
      ? { redirectTo: asPath }
      : undefined;

    return {
      authorized: false,
      redirect: {
        pathname: '/login',
        ...(query ? { query } : {}),
      },
    };
  }

  if (user && (path === '/login' || path === '/signup')) {
    const defaultRoute = getDefaultRouteForLevel(accessLevel);

    return {
      authorized: false,
      redirect: accessLevel === 5
        ? defaultRoute
        : (typeof redirectToQuery === 'string' && redirectToQuery
          ? redirectToQuery
          : defaultRoute),
    };
  }

  if (user && !isRouteAllowedForLevel(accessLevel, path)) {
    return {
      authorized: false,
      redirect: getDefaultRouteForLevel(accessLevel),
    };
  }

  return { authorized: true, redirect: null };
};
